export default __webpack_public_path__ + "static/media/ceo.e7fbd254.jpeg";